/**
 * Validation patterns for common input types
 * These patterns can be reused across the application
 */

// Website URL validation pattern
// Accepts: http://example.com, https://example.com, www.example.com, example.com
export const WEBSITE_REGEX =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(http|https))[.a-zA-Z0-9_-]+(\.[a-zA-Z-]+)+((\/)[\w#!./?_&=,'+:%()@~-]+)*(\/\w+\?[.a-zA-Z0-9_-]+=\w+(&[.a-zA-Z0-9_-]+=\w+)*)?(\/)?$/m;

// The web address error text is WEB_ADDRESS_FORMAT_MESSAGE in fieldMessages.ts.
